import { useSelector } from 'react-redux'

import { Canvas, useLoader } from '@react-three/fiber'
import { Html, useGLTF, useProgress } from '@react-three/drei'
import { Leva, useControls, folder } from 'leva'
import { Perf } from 'r3f-perf'

import Scene from './components/Scene'
import CameraControls from './components/CameraControls'
import Inspector from './components/Inspector'
import AudioManager from './components/AudioManager'

import { TextureLoader } from 'three/src/loaders/TextureLoader'
import { Suspense, useEffect, useState } from 'react'
import Interface from '../ui/Interface'

export default function Experience() {
  const { mode } = useSelector((state) => state.progress)
  const [isLevaVisible, setIsLevaVisible] = useState(false)

  const { isPerfVisible } = useControls({
    Performances: folder({
      isPerfVisible: true,
    }),
  })

  useEffect(() => {
    const isDebugMode = window.location.hash.includes('debug')
    setIsLevaVisible(isDebugMode)
  }, [])

  function Loader() {
    const { progress } = useProgress()

    return <Html center>{progress} % loaded</Html>
  }

  return (
    <>
      <Leva collapsed hidden={!isLevaVisible} />
      <Canvas flat>
        <Suspense fallback={<Loader />}>
          {isPerfVisible && isLevaVisible && <Perf position="top-left" />}
          <color attach="background" args={['#000000']} />
          {mode === 'inspection' && <Inspector />}
          <CameraControls>
            <Scene />
          </CameraControls>
        </Suspense>
      </Canvas>
      <AudioManager />
    </>
  )
}

useGLTF.preload('/models/scene/room.glb')
useLoader.preload(TextureLoader, '/textures/items/items.jpg')

for (let i = 0; i < 5; i++) {
  useGLTF.preload(`/models/items/${i}.glb`)
}
